/// <amd-module name="TFS/Admin/Common/RestClient/ResourceUsage" />
/**
 * ---------------------------------------------------------
 * Generated file, DO NOT EDIT
 * ---------------------------------------------------------
 *
 * See following wiki page for instructions on how to regenerate:
 *   https://aka.ms/azure-devops-client-generation
 *
 * Configuration file:
 *   tfs\client\resourceusage\clientgeneratorconfigs\genclient.json
 */

import { IVssPageContext, IVssRestClient, IVssRestClientOptions, RestClients } from "VSS/Platform/Context";
import { RestClientBase } from "VSS/Platform/RestClientBase";

import * as ResourceUsage from "../Models/ResourceUsage";

export interface IResourceUsageRestClient extends IVssRestClient {
    /**
     * Gets the Project Level limits and Usage for a project.
     * 
     * @param project - Project ID or project name
     */
    getProjectLimit(project: string): Promise<{ [key: string] : ResourceUsage.Usage; }>;
    /**
     */
    getLimits(): Promise<{ [key: string] : ResourceUsage.Usage; }>;
}

class ResourceUsageRestClient extends RestClientBase implements IResourceUsageRestClient {
    constructor(options: IVssRestClientOptions) {
        super(options);
    }

    /**
     * Gets the Project Level limits and Usage for a project.
     * 
     * @param project - Project ID or project name
     */
    public async getProjectLimit(
        project: string
        ): Promise<{ [key: string] : ResourceUsage.Usage; }> {

        return this.beginRequest<{ [key: string] : ResourceUsage.Usage; }>({
            apiVersion: "7.1-preview.1",
            routeTemplate: "{project}/_apis/ResourceUsage",
            routeValues: {
                project: project
            }
        });
    }

    /**
     */
    public async getLimits(
        ): Promise<{ [key: string] : ResourceUsage.Usage; }> {

        return this.beginRequest<{ [key: string] : ResourceUsage.Usage; }>({
            apiVersion: "7.1-preview.1",
            routeTemplate: "_apis/ResourceUsage"
        });
    }

}

export const ResourceUsageClientName = "IResourceUsageRestClient";

export function getResourceUsageClient(pageContext: IVssPageContext, options?: IVssRestClientOptions): IResourceUsageRestClient {
    return pageContext.getRestClient<IResourceUsageRestClient>(ResourceUsageClientName, options);
}

RestClients.add(ResourceUsageClientName, { 
    factory: ResourceUsageRestClient,
    options: {
        resourceAreaId: "240a9b11-3dc7-4aa0-b3fe-2b7dc8a4e7ea"
    }
});
